var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.914 9.442l-1.538.471a4.68 4.68 0 0 0-4.359-2.627c-3.309 0-4.731 2.824-4.731 4.71c0 1.487 1.054 4.718 4.714 4.718c2.738 0 4.191-2.198 4.376-2.588l1.624.386c-.15.587-1.993 3.908-5.983 3.908c-3.557 0-6.446-2.876-6.446-6.424s2.889-6.424 6.446-6.424c3.561 0 5.546 2.742 5.897 3.87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.81 11.143h6.476v1.714H12.81z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 13.286a1.286 1.286 0 1 0 0-2.572a1.286 1.286 0 0 0 0 2.572"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtc);
export default __webpack_public_path__ + "static/media/ctc.2cbec32d4e710bbc627dc679c8bbd1d3.svg";
export { ForwardRef as ReactComponent };